module.exports = __webpack_public_path__ + "img/view-list.75fffb21.svg";